import { Icon24StateLicense } from '@care/react-embrace-icons';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

interface SMBLicenseVerificationProps {
  sx?: SxProps<Theme>;
}

export const SMBLicenseVerification = ({ sx = [] }: SMBLicenseVerificationProps) => {
  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]} display="flex" alignItems="center" columnGap={1}>
      <Icon24StateLicense /> <Typography variant="body2">State license verified</Typography>
    </Box>
  );
};
